export default __webpack_public_path__ + "img/fvhgIEKy.263e5372.svg";